export default __webpack_public_path__ + "0816faebae870c559d01a966984faa3b.png";